export default __webpack_public_path__ + "static/media/campaigns_blue_gradient.6bdd4eb0.svg";